import React, { useEffect, useState } from 'react';
import BreadCrumb from '../Assets/breadCrumb';
import GConf from '../../AssetsM/generalConf';
import { Bounce } from 'react-reveal';
import { Button, Dimmer, Form, Icon, Input, Loader, Select, TextArea } from 'semantic-ui-react';
import useGetCamion from '../Assets/Hooks/fetchCamion';
import { toast } from 'react-toastify';
import axios from 'axios';
import useSaveNotification from '../Assets/Hooks/saveNotifFunction';


const FinishData = ({clientD, setClientD, SaveReservations}) =>{
    return(<>
            <div className='card card-body border-div shadow-sm mb-4 mt-4 '  >
                {/* <div className='mb-4 text-center' style={{fontSize : 100,}}>&#129395;</div> */}
                <h3> Info de client : </h3> 
                <div className='p-1  mb-2'>
                    <h5 className='mb-1'>الاسم و اللقب </h5>
                    <Input icon='user' iconPosition='left'  placeholder=' الاسم و اللقب ' className='w-100 border-0 shadow-sm rounded mb-1' value={clientD.Client_Name} onChange={(e) => setClientD({...clientD, Client_Name: e.target.value })} />
                </div>
                <div className='p-1 mb-2'>
                    <h5 className='mb-1'>رقم الهاتف</h5>
                    <Input icon='phone' type='number' iconPosition='left'  placeholder=' رقم الهاتف' className='w-100 border-0 shadow-sm rounded mb-1' value={clientD.Client_Phone} onChange={(e) => setClientD({...clientD, Client_Phone: e.target.value })} />
                </div>
                <div className='p-1 mb-2'>
                    <h5 className='mb-1'> بطاقة التعريف   </h5>
                    <Input icon='credit card' type='number' iconPosition='left'  placeholder=' بطاقة التعريف  ' className='w-100 border-0 shadow-sm rounded mb-1' value={clientD.Client_CIN} onChange={(e) => setClientD({...clientD, Client_CIN: e.target.value })} />
                </div>
                <div className='p-1 mb-2'>
                    <h5 className='mb-1'> سعر الحجز </h5>
                    <Input icon='dollar' type='number' iconPosition='left'  placeholder='   سعر الحجز  ' className='w-100 border-0 shadow-sm rounded mb-1' value={clientD.Client_Prix} onChange={(e) => setClientD({...clientD, Client_Prix: e.target.value })} />
                </div>
                <div className='p-1 mb-2'>
                    <h5 className='mb-1'>الدفعة الأولي </h5>
                    <Input icon='dollar' type='number' iconPosition='left'  placeholder=' الدفعة الأولي  ' className='w-100 border-0 shadow-sm rounded mb-1' value={clientD.Client_PrTranche} onChange={(e) => setClientD({...clientD, Client_PrTranche: e.target.value })} />
                </div>
                {/* <div className='p-1 mb-1'>
                <h5 className='mb-1'>  العنوان</h5>
                    <Form>
                        <TextArea  rows="2"  placeholder='العنوان' className='font-droid w-100 shadow-sm rounded mb-3' value={clientD.Adress} onChange={(e) => setClientD({...clientD, Adress: e.target.value })}/>
                    </Form> 
                </div>
                <div className='p-1 mb-2'>
                    <h5 className='mb-1'> عدد الحضور المتوقع   </h5>
                    <Input icon='users' type='number' iconPosition='left'  placeholder=' تقريبا ' className='w-100 border-0 shadow-sm rounded mb-1' value={clientD.estimationNumber} onChange={(e) => setClientD({...clientD, estimationNumber: e.target.value })} />
                </div> */}
                {/* <div className='p-1 mb-1'>
                <h5 className='mb-1'>  ملاحضات </h5>
                    <Form>
                        <TextArea  rows="2"  placeholder='قم بإدخال ملاحضات ' className='font-droid w-100 shadow-sm rounded mb-3' value={clientD.Comments} onChange={(e) => setClientD({...clientD, Comments: e.target.value })}/>
                    </Form> 
                </div> */}

                
            </div>
        </>)
}

function AjouterCamion() {
    /*#########################[Const]##################################*/
    
    let [loading, setLOD] = useState(true); 
    let [selectedDate, setSelectdDate] = useState(new Date().toISOString().split('T')[0]); 
    let [salleGenre, setSalleGenre] = useState(''); 
    let [loadingSearch, setLoadingSearch] = useState(false); 
    let [youCan, setYouCan] = useState(null); 
    let [clientD, setClientD] = useState({Name:'', Phone:'', Comments:'Ajouter par admin', Lan: 36.177334, Lng: 9.124188})
    let articleEvents = []
    const countryOptions = [
        { key: 'ax', value: 'OUVERT', text: 'العادية' },
        { key: 'af', value: 'COUVERT', text: 'المغطاة' },
        { key: 'al', value: 'DYNAMIQUE', text: 'المتنقلة' },
    ]
    let fournitureListeStart = [
        {id: 1, Name :'كرسي', qte: 0, xxxxx:''},
        {id: 2, Name :'طاولة', qte: 0, xxxxx:''},
        {id: 3, Name :'مغارف', qte: 0, xxxxx:''},
        {id: 4, Name :'صحن', qte: 0, xxxxx:''},
        {id: 5, Name :'منصة فرقة', qte: 1, xxxxx:''},
        {id: 6, Name :'منصة عروسة', qte: 1, xxxxx:''},
        {id: 7, Name :'طاولة حنة', qte: 1, xxxxx:''},
        {id: 8, Name :'سياج خارجي', qte: 0, xxxxx:''},
        {id: 9, Name :'سياج داخلي', qte: 0, xxxxx:''},
        {id: 10, Name :'خيمة', qte: 0, xxxxx:''},
        {id: 11, Name :'ثلاجة', qte: 0, xxxxx:''},
        {id: 12, Name :'قلعة', qte: 0, xxxxx:''},
        {id: 13, Name :'إطار مفروش', qte: 0, xxxxx:''},
        {id: 14, Name :'إنارة', qte: 0, xxxxx:''},
    ]
    let [fournitureListe, setFourList] = useState(fournitureListeStart); 
    /* ############### UseEffect #################*/
     
    /* ############### Functions ############*/
       

      const SaveReservations = () => {
        if (!selectedDate) { alert('أدخل اليوم المطلوب')} 
        else if (!salleGenre) {alert('أدخل نوع القاعة') } 
        else if (!clientD.Client_Name) {alert('أدخل إسم العميل  ') } 
        else {
            setLoadingSearch(true)
            axios.post(`${GConf.ApiLink}/reversation/ajouter-par-admin`, {
                date : selectedDate,
                salleGenre : salleGenre,
                clientD : clientD,
                fourListe : fournitureListe
            })
            .then(function (response) {
                 
                setLoadingSearch(false)
                alert('تم التسجيل ')
                 
                 
            })
        }
        
      }

      

      const ChangeValueOfFour = (id,value) => {
         setFourList(prevList =>
            prevList.map(item =>
            item.id === id ? { ...item, qte: Number(value) } : item
            )
        );
     }

    return ( <>
            <BreadCrumb links={GConf.BreadCrumb.CamionAdd} />
            <br />
            <div className='container-fluid'>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <h3 className='mb-3 mt-2' >  Genre des la salle : القاعة المتنقلة أم القاعة العادية  </h3>  
                        <Select placeholder='إختر نوع القاعة' fluid options={countryOptions}  onChange={(e, { value }) => setSalleGenre(value)} />
                        <h3 className='mb-3 mt-2' >  Date de reservation :  </h3>
                        <div className='row mb-3'>
                            {/* <div className='col-3 align-self-center'><Button  size='large' onClick={() => DateIsSelected()} fluid className='' icon><Icon name='search' /></Button></div> */}
                            <div className='col-12'><Input type='date' fluid size='large'   value={selectedDate} onChange={(e) => setSelectdDate(e.target.value)}  /></div>
                        </div>

                        {loadingSearch ? <Dimmer active inverted> <Loader inverted> Recherche </Loader> </Dimmer> : <></>}
                        <h5>Liste des Fournitures : </h5>
                            <div className="row">
                                     {fournitureListe.map((data,index) => <div className="col-3 mb-2" key={index}>
                                            <div className="card p-2 border-div">
                                                <div className="text-center"><h5>{data.Name}</h5></div>
                                                <h5 className='mt-3 mb-0'> <Input  size='mini' className='border-div' value={data.qte} onChange={(e) => ChangeValueOfFour(data.id, e.target.value)} fluid /> </h5>
                                                <div className="row d-none">
                                                    <div className="col-6 align-self-center"> <Button size='mini' icon> <Icon name='arrow up' /> </Button></div>
                                                    <div className="col-6 align-self-center"> <Button size='mini' icon> <Icon name='arrow down' /> </Button></div>
                                                </div>
                                            </div>
                                     </div> )}
                            </div>
                       

                        <br />
                        <br />
                        <Button className='mb-3 ' fluid onClick={() => SaveReservations()}> تــسجيل حـــجـــز  </Button>
                    </div>
                    <div className="col-12 col-lg-6">
                        <FinishData clientD={clientD} setClientD={setClientD} SaveReservations={SaveReservations} />
                    </div>

                </div>
            </div>
    </> );
}

export default AjouterCamion;